import React from 'react';

const Footer = ()  => {
    return (
        <footer className='bg-blue-100 h-12 md:h-16 flex justify-center items-center'>
            <p className='text-blue-900'>MediBooker</p>
        </footer>
    );
};

export default Footer;
